import Component from "@tunnel-components/@pages/supervision/camera/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Utils from "@Cyclope-Utils/index";
import {
  CameraLoadedActionCreator,
  ExportCameraCSVLoadedActionCreator,
} from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      activeBurger: [true, false],
      cameraListData: [], // Liste de caméra
      currentPageNumbers: 1, // nouvelle pagination
      errorserver: false,
      // itemsPerPage:1,
      itemPerRow: 3,
      loading: false,
      ongletActive: [true, false, false, false, false, false],
      ongletActiveAction: [false, false],
      openHoverCard: false,
      segmentation: false,
      // totalElements:1,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    // nouvelle pagination
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);
    // nombre d'incidents par ligne
    this.onChangeItemPerRow = this.onChangeItemPerRow.bind(this);

    this.onOpenhoverCard = this.onOpenhoverCard.bind(this);
    this.onClosehoverCard = this.onClosehoverCard.bind(this);
    this.onClickOnglet = this.onClickOnglet.bind(this);
    this.onClickOngletAction = this.onClickOngletAction.bind(this);
    this.onClickBurger = this.onClickBurger.bind(this);
    this.onSegmented = this.onSegmented.bind(this);
    this.onSelectSection = this.onSelectSection.bind(this);
    this.onExportCSVCamera = this.onExportCSVCamera.bind(this);
    this.rediRectToo = this.rediRectToo.bind(this);
  }
  /**
   * MAJ des onglets
   * @public
   * @method
   * @name removeEventBip
   * @param { void }
   * @infos "https://reactjs.org"   `${Paths.PathsNamesEnums.TUNNELWATCHINCIDENTFILE}${item.id}`
   */
  public rediRectToo = (Id: number) => (event: any): void => {
    this.props.history.push(`${Paths.PathsNamesEnums.CAMERASETTINGID}${Id}`);
    window.location.reload(false);
  };

  /**
   * @method onSelectSection
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onSelectSection = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isNumber(param) && !Lodash.isEqual(param, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        segmentation: !this.state.segmentation,
      }));
      window.location.assign(`segmentation/${param}`);
    }
  };
  /**
   * @method onExportCSVCamera
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExportCSVCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      loading: true,
      openHoverCard: false,
    }));
    {
      /** vérification de l'existence de l'élement  */
    }
    this.props
      .ExportCameraCSVLoadedActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };
  /**
   * Ouvrir la modale pour la segmentation
   * des caméras
   * @method onSegmented
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSegmented = (event: any) =>
    this.setState((state: any): any => ({
      segmentation: !this.state.segmentation,
      openHoverCard: false,
    }));
  /**
   * @method onOpenhoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenhoverCard = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openHoverCard: true }));
  };
  /**
   * @method onClosehoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosehoverCard = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ openHoverCard: false }));
  };
  /**
   * Modification des états des onglet ( )
   * @method onClickBurger
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClickBurger = (param: any) => (event: any): void => {
    /**
     * @constant
     * @name activeBurger
     * @type any[]
     */
    const activeBurger: any[] = [];
    {
      /** boucle  */
    }
    for (let i = 0; i < Math.ceil(this.state.activeBurger.length); i++) {
      activeBurger.push(false);
    }
    activeBurger[param] = true;

    // localStorage.setItem("activeBurger", param);

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ activeBurger }));
  };

  /**
   * Modification des états des onglet
   * @method onClickOngletAction
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClickOngletAction = (
    param: string,
    index: number,
    parent: number
  ) => (event: any): void => {
    /**
     * @constant
     * @name ongletActiveAction
     * @type any[]
     */
    const ongletActiveAction: any[] = [];

    /**
     * @constant
     * @name ongletActiveAction
     * @type any[]
     */
    const ongletActive: boolean[] = [];

    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.ongletActive.length); i++) {
      ongletActive.push(false);
    }

    ongletActive[parent] = true;

    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.ongletActiveAction.length); i++) {
      ongletActiveAction.push(false);
    }

    ongletActiveAction[index] = true;

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ ongletActive, ongletActiveAction }));
  };
  /**
   * Modification des états des onglet
   * @method onClickOnglet
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClickOnglet = (param: string, index: number) => (
    event: any
  ): void => {
    /**
     * @constant
     * @name ongletActive
     * @type any[]
     */
    const ongletActive: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.ongletActive.length); i++) {
      ongletActive.push(false);
    }
    ongletActive[index] = true;

    // localStorage.setItem("ongletActive", index);

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      ongletActive,
      ongletActiveAction: [false, false],
    }));
  };
  /**
   * @method onChangeItemPerRow
   * @description: MAJ du nombre de column
   * @index { number } event
   * @infos "https://reactjs.org"
   */
  public onChangeItemPerRow = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      itemPerRow: Number(target),
    }));
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      currentPageNumbers: Number(target),
    }));

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        cameraListData: nextProps.data,
        errorserver: false,
        itemsPerPage: nextProps.data.length,
        totalElements: nextProps.data.length,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      loading: false,
      errorserver: false,
      segmentation: false,
    }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));
    {
      /** action creator */
    }
    this.props
      .CameraLoadedActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    {
      /** Persistance de la possition du menu */
    }
    Utils.persistentColumnPosition();
    return (
      <Component
        {...this.props}
        {...this.state}
        rediRectToo={this.rediRectToo}
        onSelectSection={this.onSelectSection}
        onExportCSVCamera={this.onExportCSVCamera}
        onClickOngletAction={this.onClickOngletAction}
        onSegmented={this.onSegmented}
        onClosehoverCard={this.onClosehoverCard}
        onOpenhoverCard={this.onOpenhoverCard}
        onClickBurger={this.onClickBurger}
        onClickOnglet={this.onClickOnglet}
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber} // Changement de la page courante
        onChangeItemPerRow={this.onChangeItemPerRow} // Nombre d'article
      />
    );
  }
}

/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.CameraLoaded.data,
    dataCameraCsv: state.ExportCameraCSVLoaded.data,
    error: state.CameraLoaded.error,
    errorCameraCsv: state.ExportCameraCSVLoaded.error,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CameraLoadedActionCreator,
  ExportCameraCSVLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/home/container.tsx